import { cmsAxiosInstance } from '../configuration/axiosConfig';
import { ClientResponse } from '../model/ClientResponse';

export const getInformacieOCookies = async ():
  Promise<ClientResponse<string>> => {
  const {
    data,
    status,
  } = await cmsAxiosInstance.get(
    '/informacie-o-cookies',
  );

  return {
    data: data.results[0].popis,
    responseCode: status,
  };
};
